'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.makeSubline = makeSubline;

function makeSubline(arr, bool) {

  var chart = new Highcharts.Chart({
    chart: {
      renderTo: 'bottom',
      type: 'spline',
      width: window.innerWidth * 0.96,
      height: 240
    },
    title: {
      text: 'All time changes'
    },
    subtitle: {
      text: 'Drag the slider below to change current year'
    },
    xAxis: {
      title: {
        text: 'Year'
      },
      categories: [1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014],
      lineColor: 'transparent',
      minorTickLength: 0,
      tickLength: 0
    },
    yAxis: {
      //min: 0,
      title: {
        text: 'Million $'
      },
      labels: {
        //enabled: false
      },
      gridLineWidth: 0
    },
    tooltip: {
      crosshairs: true,
      // headerFormat: "{point.x:} {point.key}",
      // pointFormat: "{point.y:,.1f} Million$"
      formatter: function formatter() {
        return "<b>" + this.x + " <b><br/>" + this.series.name + "<br/>" + this.y + " Million$";
      }
    },
    legend: {
      enabled: bool,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      symbolHeight: 10,
      y: -30
    },
    plotOptions: {
      spline: {
        lineWidth: 1,
        states: {
          hover: {
            lineWidth: 6
          }
        },
        marker: {
          enabled: false
        }
      }
    },
    series: arr
  });
}
//# sourceMappingURL=data:application/json;base64,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